import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import styles from 'components/common/formElements/checkbox/styles.module.scss';

interface Props {
  label: string;
  onChange: (str: string, mode: string) => void;
  className: string;
}

const Checkbox: React.FC<Props> = ({ label, className, onChange }) => {
  const [checked, setСhecked] = useState(false);
  useEffect(() => {
    if (checked) {
      onChange(label, 'add');
    }
    if (!checked) {
      onChange(label, 'remove');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  return (
    <label className={cn(styles.root, className)}>
      <input
        className={styles.checkbox}
        type="checkbox"
        checked={checked}
        onChange={() => {
          setСhecked(!checked);
        }}
      />
      <span className={styles.label}>{label}</span>
    </label>
  );
};

export default Checkbox;
